import { render, staticRenderFns } from "./MyCollect.vue?vue&type=template&id=df41dc56&scoped=true&"
import script from "./MyCollect.vue?vue&type=script&lang=js&"
export * from "./MyCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df41dc56",
  null
  
)

export default component.exports